import { render } from "./coursewareInfo.vue?vue&type=template&id=182fe1bc&scoped=true"
import script from "./coursewareInfo.vue?vue&type=script&lang=js"
export * from "./coursewareInfo.vue?vue&type=script&lang=js"

import "./coursewareInfo.vue?vue&type=style&index=0&id=182fe1bc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182fe1bc"]])

export default __exports__